"use strict";
/********************************************************************************
  HxNativeInterop.ts

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeNativeInterop = exports.HxNativeInterop = void 0;
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxNativeInterop = /** @class */ (function () {
    function HxNativeInterop(interopBridge) {
        var _this = this;
        // For ActorWithResults, actorCallbackMap stores requestId and object with callbacks (Object Keys are successResultsAvailableCallback, failureResultsAvailableCallback, successCompletionCallback and failureCompletionCallback)
        // For ActorWithoutResults, actorCallbackMap stores requestId and object with completion callback (Object Keys are successCompletionCallback and failureCompletionCallback)
        this.actorCallbackMap = new Map();
        this.loadCallbackMap = new Map();
        this.nextRequestId = 1;
        this.eventHandler = undefined;
        this.healthDelegates = [];
        this.interopBridge = interopBridge;
        this.interopBridge.setProcessMessageFromNativeEventHandler(function (event) { return _this.onEvent(event); });
    }
    HxNativeInterop.prototype.setEventHandler = function (handler) {
        this.eventHandler = handler;
    };
    HxNativeInterop.prototype.onEvent = function (data) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var result, requestId, callback, _f, _g, event, e_1_1, _h, _j, action;
            var e_1, _k, e_2, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        // Support clients sending us events in JSON or object format. Try to parse if it's a string.
                        if (typeof data === "string") {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (e) {
                                // no-op
                            }
                        }
                        if (typeof data === "object" && data['source'] === "HxJsInterop") {
                            result = data['result'];
                            requestId = data['requestId'];
                            callback = this.loadCallbackMap.get(requestId);
                            if (callback !== undefined) {
                                this.loadCallbackMap.delete(requestId);
                                this.invokeHealthDelegatesForLoadResult(callback.objectId, data);
                                callback.callback(result);
                            }
                        }
                        if (!(typeof data === "object" && data['source'] === "HxJsInteropEvent")) return [3 /*break*/, 11];
                        if (data['dataEvents'].length > 0)
                            this.invokeHealthDelegatesForDataEvent(data);
                        (_a = this.eventHandler) === null || _a === void 0 ? void 0 : _a.onNotificationsBegin();
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 8, 9, 10]);
                        _f = __values(data['dataEvents']), _g = _f.next();
                        _m.label = 2;
                    case 2:
                        if (!!_g.done) return [3 /*break*/, 7];
                        event = _g.value;
                        if (!(event.type === "ObjectChanged")) return [3 /*break*/, 3];
                        (_b = this.eventHandler) === null || _b === void 0 ? void 0 : _b.onObjectChanged(event.data);
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(event.type === "ObjectDeleted")) return [3 /*break*/, 4];
                        (_c = this.eventHandler) === null || _c === void 0 ? void 0 : _c.onObjectDeleted(event.data);
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(event.type === "CollectionChanged")) return [3 /*break*/, 6];
                        return [4 /*yield*/, ((_d = this.eventHandler) === null || _d === void 0 ? void 0 : _d.onCollectionChanged(event.data))];
                    case 5:
                        _m.sent();
                        _m.label = 6;
                    case 6:
                        _g = _f.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _m.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_g && !_g.done && (_k = _f.return)) _k.call(_f);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        try {
                            for (_h = __values(data['actionEvents']), _j = _h.next(); !_j.done; _j = _h.next()) {
                                action = _j.value;
                                this.emitActionCompletion(action);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_l = _h.return)) _l.call(_h);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        (_e = this.eventHandler) === null || _e === void 0 ? void 0 : _e.onNotificationsEnd();
                        _m.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    HxNativeInterop.prototype.emitActionCompletion = function (data) {
        var result = data['result'];
        var requestId = data['requestId'];
        var success = data['success'];
        var callbacks = this.actorCallbackMap.get(requestId);
        if (callbacks !== undefined) {
            this.actorCallbackMap.delete(requestId);
            if (data['action'] === "ActorWithResultsCompleted") {
                if (success) {
                    callbacks.successResultsAvailableCallback(result);
                }
                else {
                    callbacks.failureResultsAvailableCallback(result);
                }
                if (callbacks.successCompletionCallback !== undefined) {
                    this.actorCallbackMap.set(requestId, {
                        actorId: callbacks.actorId,
                        successCompletionCallback: callbacks.successCompletionCallback,
                        failureCompletionCallback: callbacks.failureCompletionCallback
                    });
                }
                else {
                    this.invokeHealthDelegatesForActorCompletion(callbacks.actorId, data);
                }
            }
            else {
                if (success) {
                    callbacks.successCompletionCallback(result);
                }
                else {
                    callbacks.failureCompletionCallback(result);
                }
                if (callbacks.successResultsAvailableCallback !== undefined) {
                    this.actorCallbackMap.set(requestId, {
                        actorId: callbacks.actorId,
                        successResultsAvailableCallback: callbacks.successResultsAvailableCallback,
                        failureResultsAvailableCallback: callbacks.failureResultsAvailableCallback
                    });
                }
                else {
                    this.invokeHealthDelegatesForActorCompletion(callbacks.actorId, data);
                }
            }
        }
    };
    HxNativeInterop.prototype.getInitialObjects = function () {
        return this.interopBridge.getInitialObjects();
    };
    HxNativeInterop.prototype.loadHelper = function (action, objectId, args, callback) {
        if (callback) {
            this.loadCallbackMap.set(this.nextRequestId, { objectId: objectId, callback: callback });
        }
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: action,
            args: args,
            requestId: this.nextRequestId++,
            timeStampStartJs: new Date().valueOf()
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.loadObject = function (objectId, callback) {
        this.loadHelper("loadObject", objectId, { objectId: objectId.toString() }, callback);
    };
    HxNativeInterop.prototype.loadObjectByHandle = function (handle, objectType, callback) {
        this.loadHelper("loadObjectByHandle", HxObjectID_1.default.objectIdNil, { handle: handle, objectType: objectType }, callback);
    };
    HxNativeInterop.prototype.loadCollection = function (collectionId, callback) {
        this.loadHelper("loadCollection", collectionId, { collectionId: collectionId.toString() }, callback);
    };
    HxNativeInterop.prototype.loadVirtualizedCollection = function (collectionId, callback) {
        this.loadHelper("loadVirtualizedCollection", collectionId, { collectionId: collectionId.toString() }, callback);
    };
    HxNativeInterop.prototype.loadVirtualizedCollectionItems = function (collectionId, itemIds, callback) {
        this.loadHelper("loadVirtualizedCollectionItems", collectionId, { collectionId: collectionId.toString(), itemIds: itemIds }, callback);
    };
    HxNativeInterop.prototype.loadCollectionByTimeRange = function (collectionId, sortId, start, end, callback) {
        this.loadHelper("loadCollectionByTimeRange", collectionId, { collectionId: collectionId.toString(), sortId: sortId, start: start.valueOf(), end: end.valueOf() }, callback);
    };
    HxNativeInterop.prototype.deactivateObject = function (objectId, storageSequenceNumber) {
        this.loadHelper("deactivateObject", objectId, { objectId: objectId.toString(), storageSequenceNumber: storageSequenceNumber }, undefined);
    };
    // HxJsActiveSet.runActor will return completion through INativeInteropMessageBridge. On event, ActorWithoutResultsCompletionCallback is called.
    HxNativeInterop.prototype.runActor = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction, requestId, completionResolverCallback, completionRejecterCallback) {
        this.actorCallbackMap.set(requestId, {
            actorId: actorId,
            successCompletionCallback: completionResolverCallback,
            failureCompletionCallback: completionRejecterCallback
        });
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "runActor",
            timeStampStartJs: new Date().valueOf(),
            args: {
                actorId: actorId,
                targetIds: targetIds,
                args: args,
                actorCompletionNotificationType: actorCompletionNotificationType,
                runAsUndoableAction: runAsUndoableAction,
                requestId: requestId
            },
        };
        this.interopBridge.postMessageToNative(msg);
    };
    // HxJsActiveSet.runActorWithResults will return Results and Completion through INativeInteropMessageBridge.
    // When results are available onActorWithResultsAvailableCallback is called.
    // On completion, onActorWithResultsCompletionCallback is called.
    HxNativeInterop.prototype.runActorWithResults = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction, requestId, resultsAvailableResolverCallback, resultsAvailableRejecterCallback, completionResolverCallback, completionRejecterCallback) {
        var sendCompletionInfo = completionResolverCallback !== undefined && completionRejecterCallback !== undefined;
        this.actorCallbackMap.set(requestId, {
            actorId: actorId,
            successResultsAvailableCallback: resultsAvailableResolverCallback,
            failureResultsAvailableCallback: resultsAvailableRejecterCallback,
            successCompletionCallback: completionResolverCallback,
            failureCompletionCallback: completionRejecterCallback
        });
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "runActorWithResults",
            timeStampStartJs: new Date().valueOf(),
            args: {
                actorId: actorId,
                targetIds: targetIds,
                args: args,
                actorCompletionNotificationType: actorCompletionNotificationType,
                runAsUndoableAction: runAsUndoableAction,
                requestId: requestId,
                sendCompletionInfo: sendCompletionInfo
            },
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.undoAction = function (requestId, requestIdForRedo) {
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "undoAction",
            args: {
                requestId: requestId, requestIdForRedo: requestIdForRedo
            },
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.dismissUndo = function (requestId) {
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "dismissUndo",
            args: {
                requestId: requestId
            },
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.dismissAllUndo = function () {
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "dismissAllUndo",
            args: {},
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.connectActiveSet = function () {
        var msg = {
            source: HxNativeInterop.c_nativeInteropSource,
            action: "connectActiveSet",
            args: {},
        };
        this.interopBridge.postMessageToNative(msg);
    };
    HxNativeInterop.prototype.registerHealthDelegate = function (delegate) {
        this.healthDelegates.push(delegate);
    };
    HxNativeInterop.prototype.unregisterHealthDelegate = function (delegate) {
        var index = this.healthDelegates.findIndex(function (item) { return item === delegate; });
        if (index !== -1) {
            this.healthDelegates.splice(index, 1);
        }
    };
    HxNativeInterop.prototype.invokeHealthDelegatesForLoadResult = function (objectId, healthData) {
        if (this.healthDelegates.length > 0) {
            var healthDataOut_1 = {
                objectId: objectId,
                itemCount: healthData.itemCount,
                timeStampStartJs: new Date(healthData.timeStampStartJs),
                timeStampStartCpp: new Date(healthData.timeStampStartCpp),
                timeStampEndCpp: new Date(healthData.timeStampEndCpp),
                timeStampEndJs: new Date(),
                storageTimeNs: healthData.storageTimeNs,
            };
            this.healthDelegates.forEach(function (delegate) { var _a; return (_a = delegate.loadResult) === null || _a === void 0 ? void 0 : _a.call(delegate, healthDataOut_1); });
        }
    };
    HxNativeInterop.prototype.invokeHealthDelegatesForActorCompletion = function (actorId, healthData) {
        if (this.healthDelegates.length > 0) {
            var healthDataOut_2 = {
                actorId: actorId,
                timeStampStartJs: new Date(healthData.timeStampStartJs),
                timeStampStartCpp: new Date(healthData.timeStampStartCpp),
                timeStampEndCpp: new Date(healthData.timeStampEndCpp),
                timeStampEndJs: new Date(),
            };
            this.healthDelegates.forEach(function (delegate) { var _a; return (_a = delegate.actorResult) === null || _a === void 0 ? void 0 : _a.call(delegate, healthDataOut_2); });
        }
    };
    HxNativeInterop.prototype.invokeHealthDelegatesForDataEvent = function (healthData) {
        if (this.healthDelegates.length > 0) {
            var healthDataOut_3 = {
                timeStampCpp: new Date(healthData.timeStampCpp),
                timeStampJs: new Date(),
            };
            this.healthDelegates.forEach(function (delegate) { var _a; return (_a = delegate.dataEvent) === null || _a === void 0 ? void 0 : _a.call(delegate, healthDataOut_3); });
        }
    };
    HxNativeInterop.c_nativeInteropSource = "HxNativeInterop";
    return HxNativeInterop;
}());
exports.HxNativeInterop = HxNativeInterop;
exports.fakeNativeInterop = {
    setEventHandler: function (_handler) { return undefined; },
    getInitialObjects: function () {
        var initialObjects = {
            namedObjectIDs: {
                ObjectIDNil: 'fake ObjectIDNil'.padEnd(92, ' '),
                Root: 'fake Root'.padEnd(92, ' '),
            },
            objects: [],
            collections: [],
            globalCounterSeed: { seed: 1 },
            jsAppProcessIdentifier: { processId: 3 }
        };
        return JSON.stringify(initialObjects);
    },
    loadObject: function (_objectId, callback) { return callback(undefined); },
    loadObjectByHandle: function (_handle, _objectType, callback) { return callback(undefined); },
    loadCollection: function (_collectionId, callback) { return callback(undefined); },
    loadVirtualizedCollection: function (_collectionId, callback) { return callback(undefined); },
    loadVirtualizedCollectionItems: function (_collectionId, _itemIds, callback) { return callback(undefined); },
    loadCollectionByTimeRange: function (_collectionId, _sortId, _start, _end, callback) {
        return callback(undefined);
    },
    deactivateObject: function (_objectId, _storageSequenceNumber) { return undefined; },
    runActor: function (_actorId, _targetIds, _args, _actorCompletionNotificationType, _runAsUndoableAction, _requestId, _completionResolverCallback, _completionRejecterCallback) { return _completionRejecterCallback('fake callback'); },
    runActorWithResults: function (_actorId, _targetIds, _args, _actorCompletionNotificationType, _runAsUndoableAction, _requestId, _resultsAvailableResolverCallback, _resultsAvailableRejecterCallback, _completionResolverCallback, _completionRejecterCallback) { return _resultsAvailableRejecterCallback('fake callback'); },
    undoAction: function (_requestId, _requestIdForRedo) { return undefined; },
    dismissUndo: function (_requestId) { return undefined; },
    dismissAllUndo: function () { return undefined; },
    connectActiveSet: function () { return undefined; },
    registerHealthDelegate: function (_delegate) { return undefined; },
    unregisterHealthDelegate: function (_delegate) { return undefined; },
};
exports.default = HxNativeInterop;
